import { Component, OnInit } from '@angular/core';
import { AuthService } from '../app/auth/auth.service';
import { Observable } from 'rxjs';
import { User } from '../app/auth/user';
import { Router, ActivatedRoute, ParamMap, NavigationStart, NavigationEnd, NavigationError, Event } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  routerName: string;
  sideNav: any;
  login:any
  constructor(
    private authService: AuthService,
    private activeroute: ActivatedRoute,
    private route: Router,
  ) {
    this.authService.currentUser.subscribe(x => this.currentUser = x);
    this.authService.SideNavClick$.subscribe(side=>{
     this.sideNav = side;
    });
    
  }
  title = 'EasyRin';
  currentUser: any;
  isLoggedIn$: Observable<boolean>;
  ngOnInit() {
    this.isLoggedIn$ = this.authService.isLoggedIn;
    this.login=localStorage.getItem('login')
    // this.route.queryParams.subscribe(params => {
    //   this.routerName = params['name'];
    // });
    this.route.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        this.routerName = event.url;
        if (this.routerName == '/' || this.routerName == '/login') {
          this.currentUser = '';
          // this.authService.logout();
        }
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Surface silently-swallowed navigation failures (e.g. lazy chunk load errors)
        console.error('Navigation failed:', event.url, event.error);
      }
    });
  }
  isLoggedIn() {
    return this.authService.isLoggedIn2();
  }
}
